import {
  Button,
  VStack,
  useColorModeValue,
  Box,
  Text,
  Icon,
} from "@chakra-ui/react";
import React from "react";
import { AiFillHome } from "react-icons/ai";
import { FaTelegramPlane, FaMobile } from "react-icons/fa";
import { BsLightningChargeFill } from "react-icons/bs";
import { RiMessage2Fill } from "react-icons/ri";
import { IoMdSettings } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";

const ButtonsList = [
  {
    title: "Dashboard",
    icon: AiFillHome,
    link: "/",
  },
  {
    title: "OTP Operator1",
    icon: FaMobile,
    link: "/server1",
  },
  {
    title: "OTP Operator2",
    icon: FaMobile,
    link: "/server2",
  },
  {
    title: "OTP Operator3",
    icon: FaMobile,
    link: "/server3",
  },
  {
    title: "OTP Operator4",
    icon: FaMobile,
    link: "/server4",
  },
  {
    title: "OTP Operator5",
    icon: FaMobile,
    link: "/server5",
  },
  {
    title: "Top up balance",
    icon: BsLightningChargeFill,
    link: "/payment",
  },
  {
    title: "Activation",
    icon: RiMessage2Fill,
    link: "/otphistory",
  },
  {
    title: "Support",
    icon: FaTelegramPlane,
    link: "/support",
  },
  {
    title: "Setting",
    icon: IoMdSettings,
    link: "/setting"
  },
];

const LeftSideBar = ({ closeDrawer, status = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Premium Styles
  const activeBg = useColorModeValue("brand.500", "brand.200");
  const activeColor = useColorModeValue("white", "gray.900");
  const inactiveColor = useColorModeValue("gray.600", "gray.400");
  const hoverBg = useColorModeValue("gray.100", "whiteAlpha.100");
  const indicatorBg = useColorModeValue("whiteAlpha.600", "blackAlpha.400");

  return (
    <VStack
      w={{ base: "100%", lg: "21%" }}
      position="sticky"
      top="0"
      spacing={3}
      align="stretch"
      pt={6}
      px={4}
    >
      {ButtonsList.map((el) => {
        const isActive = location.pathname === el.link;
        return (
          <Button
            key={el.title}
            onClick={() => {
              navigate(el.link);
              if (status && closeDrawer) {
                closeDrawer();
              }
            }}
            variant="ghost"
            justifyContent="flex-start"
            position="relative"
            overflow="hidden"
            h="auto"
            py={3.5}
            px={5}
            rounded="xl"
            bg={isActive ? activeBg : "transparent"}
            color={isActive ? activeColor : inactiveColor}
            _hover={{
              bg: isActive ? activeBg : hoverBg,
              transform: "translateX(5px)",
              shadow: "sm"
            }}
            _active={{
              transform: "scale(0.98)",
            }}
            transition="all 0.2s ease"
            leftIcon={<Icon as={el.icon} boxSize={5} />}
            iconSpacing={4}
          >
            <Text fontSize="1.05rem" fontWeight={isActive ? "700" : "500"}>
              {el.title}
            </Text>

            {/* Active Indicator (Optional decorative element) */}
            {isActive && (
              <Box
                position="absolute"
                right="0"
                top="50%"
                transform="translateY(-50%)"
                w="4px"
                h="50%"
                bg={indicatorBg}
                roundedLeft="full"
              />
            )}
          </Button>
        );
      })}
    </VStack>
  );
};

export default LeftSideBar;
